// ── Equipo interno de Adigital, por país ────────────────────────────────────
// IDs de usuarios del equipo propio (no agencias ni clientes reales). Se usan para
// dos cosas en la sección "Nuevas Cotizaciones" de /admin/cotizaciones:
//   1. EXCLUIRLOS del bucket "agencias/clientes del propio país" — un interno que se
//      pone rol 'agencia'/'cliente' para armar presentaciones NO debe colarse ahí.
//   2. INCLUIR al equipo del OTRO país como bucket propio (Chile ve a Perú y viceversa),
//      sin importar el rol que tengan en el momento.
//
// Se compara SIEMPRE por ID (regla 10.7), nunca por nombre ni por rol (el rol es
// mutable). Las claves usan el país en formato NOMBRE 'Chile'/'Perú' (regla 10.53),
// consistente con `cotizaciones.pais` y con el país de sesión (`auth.pais`).
export const EQUIPO_INTERNO = {
  Chile: [1, 904], // Ignacio (CL), Nico Soto
  Perú: [4, 306], // Ignacio (PE), Karin
};

// Set plano con TODOS los IDs internos (de cualquier país), para excluir la fuga
// del bucket agencias/clientes de una sola pasada.
export const EQUIPO_INTERNO_IDS = new Set(Object.values(EQUIPO_INTERNO).flat());

// True si `usuarioId` pertenece al equipo interno de cualquier país.
export const esEquipoInterno = (usuarioId) => EQUIPO_INTERNO_IDS.has(usuarioId);

// IDs del equipo interno de un país puntual (nombre 'Chile'/'Perú'). [] si desconocido.
export const equipoInternoDePais = (pais) => EQUIPO_INTERNO[pais] || [];
